import React, { useEffect, useState } from 'react';
import {
  ButtonWithAction,
  Cluster,
  FormContainer,
  FormInput,
  FormTextarea,
  Text,
  util,
  Box,
} from '@thecb/components';

import {
  formatCurrencyInput,
  convertToISOFormat,
} from '../../../utils/helpers';

import {
  wireReducer,
  wireMapStateToProps,
  wireMapDispatchToProps,
} from '../CheckoutForm.state';
import { useSelector } from 'react-redux';
import { WIRE } from '../../../utils/constants';
import { useLocation, useNavigate } from 'react-router-dom';
import DatePicker from '../../../components/date-picker';
import { requireErrors, paymentAmountErrors } from './shared-constants';

let WirePaymentCheckoutForm = ({
  actions,
  fields,
  makePayment,
  remainingBalance,
  processBtnText,
  splitTenderAllowed,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [errors, handleErrors] = useState(false);
  const { isLoading } = useSelector((state) => state.checkout);

  useEffect(() => {
    if (remainingBalance) {
      actions.fields.amount.set(formatCurrencyInput(remainingBalance));
    }
  }, [remainingBalance]);

  const handleWirePaymentSubmit = util.general.generateClickHandler(
    { fields },
    () => handleErrors(true),
    () =>
      makePayment({
        amount_given: Number(fields.amount.rawValue),
        name: fields.name.rawValue,
        effective_date: convertToISOFormat(fields.effectiveDate.rawValue),
        description: fields.description.rawValue,
        payment_tender_type: WIRE,
        navigate,
        location,
      }),
  );

  return (
    <FormContainer>
      <FormInput
        id="wire-payment-amt"
        type="number"
        labelTextWhenNoError="Payment Amount"
        errorMessages={paymentAmountErrors}
        field={fields.amount}
        errors={fields.errors}
        fieldActions={actions.fields.amount}
        labelTextVariant="p"
        errorTextVariant="p"
        disabled={!splitTenderAllowed}
      />
      <Text fontSize={'1.25em'}>Wire Transfer Information</Text>
      <FormInput
        id="wire-name"
        labelTextWhenNoError="Name"
        errorMessages={requireErrors('Name is required')}
        field={fields.name}
        showErrors={errors}
        fieldActions={actions.fields.name}
        labelTextVariant="p"
        errorTextVariant="p"
      />
      <DatePicker
        label="Effective Date"
        labelTextWhenNoError="Effective Date"
        id="wire-effective-date"
        field={fields.effectiveDate}
        fieldActions={actions.fields.effectiveDate}
        errorMessages={requireErrors('Effective Date is required')}
        showErrors={errors}
        errorTextVariant="p"
        fullWidth
      />
      <FormTextarea
        id="wire-description"
        labelTextWhenNoError="Description"
        field={fields.description}
        showErrors={errors}
        fieldActions={actions.fields.description}
        labelTextVariant="p"
        errorTextVariant="p"
        maxLength={200}
        resize="none"
        rows={3}
      />
      <Box padding="16px 0 0">
        <Cluster>
          <ButtonWithAction
            text={'Back to Cart'}
            action={() => navigate('/pos/cart')}
            variant="secondary"
            dataQa="view-cart"
            extraStyles="margin-left: 0"
            textExtraStyles="font-size: 1rem;"
          />
          <ButtonWithAction
            id="submit-wire-payment-btn"
            disabled={
              isLoading ||
              fields.amount.rawValue <= 0 ||
              fields.amount.hasErrors
            }
            isLoading={isLoading}
            text={processBtnText}
            action={handleWirePaymentSubmit}
            textExtraStyles="font-size: 1rem;"
          />
        </Cluster>
      </Box>
    </FormContainer>
  );
};

WirePaymentCheckoutForm.reducer = wireReducer;
WirePaymentCheckoutForm.mapStateToProps = wireMapStateToProps;
WirePaymentCheckoutForm.mapDispatchToProps = wireMapDispatchToProps;

export default WirePaymentCheckoutForm;
